import { injectable } from "inversify";
import {
  HttpUtmkCoordinateResponse,
  IUtmkCoordinateInfoParser,
} from "../addressRepository.types";
import { IUtmkCoordinateInfo, UtmkCoordinateInfo } from "@/domain/entities/address";
import { ParseError } from "@/repositories/shared/errors/parseError";
import { Result, ok } from "neverthrow";

@injectable()
export class UtmkCoordinateInfoParser implements IUtmkCoordinateInfoParser {
  toDomain(
    response: HttpUtmkCoordinateResponse
  ): Result<IUtmkCoordinateInfo, ParseError> {
    try {
      const utmkCoordinateInfoData: IUtmkCoordinateInfo = {
        utmkX: response.results.juso?.[0]?.entX ?? "0",
        utmkY: response.results.juso?.[0]?.entY ?? "0",
      };
      const utmkCoordinateInfo = new UtmkCoordinateInfo(utmkCoordinateInfoData);
      return ok(utmkCoordinateInfo);
    } catch (error: any) {
      return error(new ParseError(error.message));
    }
  }
}
